import * as l from "./links";
import { defaultJiData } from "./default";
import { UnityData } from "../../../LinkDataInterface";
import * as p from "../permanant";

export const hermine: UnityData = {
  ...defaultJiData,
  groups: [
    [
      l.odjPleniaire,
      l.odjAnim,
      l.odjTech,
      l.odjPromo,
      l.odjPres,
      l.listComity,
      p.coordonnesPJ,
      l.listTelegram,
    ],
    [l.budget, l.dossierTresorerie, l.ag, l.status],
    [p.bexio, p.ubs, p.tva, p.twint, p.paiementEnLigne],
    [l.planningPublication, l.textesPublication],
    [l.suiviAnim, l.planningParSalle, p.formulaireAnim, p.accreds],
    [l.besoinTech, l.deadlineTech, p.espaceStaff, p.github],
  ],
};
